import React, { useMemo, useEffect } from 'react';
import "../../component/styles/styles.scss";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Loader from '../../component/loader';
import { Useimagepickercontext } from '../../utils/Hooks';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import { useQueryClient } from 'react-query';
import ImagepickerModal from "./Imagepicker-modal";
import Appbutton from '../../component/button';
import RemoveIcon from '@mui/icons-material/Remove';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import AddIcon from '@mui/icons-material/Add';
import ColorThief from 'colorthief';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';


export default function Imagepicker() {
    const { handleColors,
        colors,
        rgbToHex,
        thumbs,
        files, copy, setColors, setFiles, errorMessage, setErrorMessage, useGetRandomImage, showDefaultImage, setStoreImageColors,
        storeImageColors, setOpen, open, storeImagePath, setStoreImagePath, setUnsplashImageColors, unsplashImageColors } = Useimagepickercontext();


    const { isLoading, data } = useGetRandomImage();

    const useQuery = useQueryClient();


    useEffect(() => {

        // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
        return () => {
            files.forEach(file => URL.revokeObjectURL(file.preview));
            setFiles([]);
            setColors([]);
            setStoreImageColors([]);
            setErrorMessage(false);
            setStoreImagePath((prevState) => ({
                ...prevState,
                uploadedImageColors: 5,
                colorCounter: 5,
                unsplashImageColorCounter: 5,
                unsplashImageComponent: false,
            }))
        }
    }, []);


    const handleShuffleImage = () => {
        useQuery.refetchQueries("random-image")
    }

    const handleAppButton = () => {
        setOpen(true);
    }

    const handleValueIncrement = () => {
        setStoreImagePath((prevState) => {
            if (showDefaultImage) {
                if (prevState.colorCounter >= 9) {
                    return prevState
                }
                return {
                    ...prevState,
                    colorCounter: prevState.colorCounter + 1,
                };
            } else if (storeImagePath.unsplashImageComponent) {
                if (prevState.unsplashImageColorCounter >= 9) {
                    return prevState
                }
                return {
                    ...prevState,
                    unsplashImageColorCounter: prevState.unsplashImageColorCounter + 1,
                };
            } else {
                if (prevState.uploadedImageColors >= 9) {
                    return prevState
                }
                return {
                    ...prevState,
                    uploadedImageColors: prevState.uploadedImageColors + 1,
                };
            }
        });
    }

    const handleValuedecrement = () => {
        setStoreImagePath((prevState) => {
            if (showDefaultImage) {
                if (prevState.colorCounter <= 2) {
                    return prevState
                }
                return {
                    ...prevState,
                    colorCounter: prevState.colorCounter - 1
                };
            } else if (storeImagePath.unsplashImageComponent) {
                if (prevState.unsplashImageColorCounter <= 2) {
                    return prevState
                }
                return {
                    ...prevState,
                    unsplashImageColorCounter: prevState.unsplashImageColorCounter - 1,
                };
            } else {
                if (prevState.uploadedImageColors <= 2) {
                    return prevState
                }
                return {
                    ...prevState,
                    uploadedImageColors: prevState.uploadedImageColors - 1
                };
            }
        });
    }

    useEffect(() => {
        const colorThief = new ColorThief();
        const img = new Image();
        let palette;

        if (showDefaultImage) {
            img.onload = async () => {
                palette = await colorThief.getPalette(img, storeImagePath.colorCounter);
                setColors(palette);

                setStoreImageColors([]);
                setUnsplashImageColors([]);
                setStoreImagePath(prevState => ({
                    ...prevState,
                    value: 0,
                }));
            }
            img.crossOrigin = "Anonymous";
            img.src = data && data[0].urls.regular;
        } else if (storeImagePath.unsplashImageComponent) {
            img.onload = async () => {
                setUnsplashImageColors([]);
                palette = await colorThief.getPalette(img, storeImagePath.unsplashImageColorCounter);
                setUnsplashImageColors(palette);
                setColors([]);
                setStoreImagePath(prevState => ({
                    ...prevState,
                    colorCounter: 5
                }));
                setStoreImageColors([]);
                setStoreImagePath(prevState => ({
                    ...prevState,
                    value: 0,
                }));
            };
            img.crossOrigin = "Anonymous";
            img.src = storeImagePath.unsplashImagePath

        } else {
            for (const uploadedFile of files) {
                const uploadedImg = new Image();
                uploadedImg.src = URL.createObjectURL(uploadedFile);
                uploadedImg.onload = async () => {
                    const palette = await colorThief.getPalette(uploadedImg, storeImagePath.uploadedImageColors);
                    setStoreImageColors(palette);
                    setColors([]);
                    setStoreImagePath(prevState => ({
                        ...prevState,
                        value: 0,
                    }));
                    URL.revokeObjectURL(uploadedImg.src); // Cleanup to prevent memory leaks
                };
            }
        }

        return () => {
            // Uncomment if resetting storeImagePath.colorCounter is necessary
            // setStoreImagePath(prevState => ({
            //     ...prevState,
            //     colorCounter: 5,
            //     unsplashImageColorCounter: 5,
            //     uploadedImageColors: 5
            // }));
        };
    }, [storeImagePath.colorCounter, storeImagePath.uploadedImageColors, storeImagePath.unsplashImageColorCounter]);

    return (
        <>
            {isLoading ? <Loader /> : (
                <>
                    <Container fixed>
                        <div className="red-color-pallete-wrapper">
                            <h1>Image Picker</h1>
                            <p>Upload a photo to extract it's potential colors</p>
                            <div className='gridWrapper'>
                                <Grid container spacing={4}>
                                    <Grid item xs={5}>
                                        <h5 className='copy-text'>Click to copy!</h5>
                                        <div className='color-palette-wrapper'>
                                            {showDefaultImage ? (
                                                // Render colors from default image
                                                colors && colors.map((colorPalette, index) => {
                                                    const hexColor = rgbToHex(colorPalette[0], colorPalette[1], colorPalette[2]);
                                                    return (
                                                        <div
                                                            key={index}
                                                            className='grid-layout'
                                                            style={{ backgroundColor: `rgb(${colorPalette[0]}, ${colorPalette[1]}, ${colorPalette[2]})` }}
                                                            onClick={() => handleColors(hexColor)}
                                                        >
                                                            {copy === hexColor && <h5>Copied!</h5>}
                                                            <p className='overlay-text'>{hexColor}</p>
                                                        </div>
                                                    );
                                                })
                                            ) : storeImagePath.unsplashImageComponent ? (
                                                // Render colors from default image
                                                unsplashImageColors && unsplashImageColors.map((colorPalette, index) => {
                                                    const hexColor = rgbToHex(colorPalette[0], colorPalette[1], colorPalette[2]);
                                                    return (
                                                        <div
                                                            key={index}
                                                            className='grid-layout'
                                                            style={{ backgroundColor: `rgb(${colorPalette[0]}, ${colorPalette[1]}, ${colorPalette[2]})` }}
                                                            onClick={() => handleColors(hexColor)}
                                                        >
                                                            {copy === hexColor && <h5>Copied!</h5>}
                                                            <p className='overlay-text'>{hexColor}</p>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                // Render colors from uploaded image
                                                storeImageColors && storeImageColors.map((colorPalette, index) => {
                                                    const hexColor = rgbToHex(colorPalette[0], colorPalette[1], colorPalette[2]);
                                                    return (
                                                        <div
                                                            key={index}
                                                            className='grid-layout'
                                                            style={{ backgroundColor: `rgb(${colorPalette[0]}, ${colorPalette[1]}, ${colorPalette[2]})` }}
                                                            onClick={() => handleColors(hexColor)}
                                                        >
                                                            {copy === hexColor && <h5>Copied!</h5>}
                                                            <p className='overlay-text'>{hexColor}</p>
                                                        </div>
                                                    );
                                                })
                                            )}
                                        </div>
                                        <div className="buttonWrapper">
                                            <Appbutton disabled={false} handleAppButton={handleAppButton} bgColor="#2b4d7a">
                                                <p><UploadFileIcon sx={{ fontSize: "20px", marginRight: "10px" }} />Browse</p>
                                            </Appbutton>
                                            <div className='counter-button-wrapper'>
                                                <RemoveIcon onClick={handleValuedecrement} sx={{ fontSize: "18px", cursor: "pointer" }} />
                                                <input type='text' value={showDefaultImage ? storeImagePath.colorCounter : storeImagePath.unsplashImageComponent ? storeImagePath.unsplashImageColorCounter : storeImagePath.uploadedImageColors} disabled />
                                                <AddIcon onClick={handleValueIncrement} sx={{
                                                    fontSize: "18px", cursor: "pointer"
                                                }} />
                                                <Tooltip title="Number of colors to extract." arrow>
                                                    <InfoOutlinedIcon sx={{ fontSize: "20px", borderLeft: "1px solid #dedede", paddingLeft: "5px", height: "30px" }} />
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <div className='color-wrapper'>
                                            {(showDefaultImage) || (storeImagePath.unsplashImageComponent) ? <img src={storeImagePath.unsplashImagePath === "" ? storeImagePath.defaultImagePath : storeImagePath.unsplashImagePath} alt='' /> : (
                                                <>
                                                    {thumbs}
                                                </>
                                            )}
                                            {(showDefaultImage || storeImagePath.unsplashImageComponent) && (
                                                <p className='photo-courtesy-text'>Photo courtesy: <a href={`${storeImagePath.userLink}?utm_source=ShadeSense&utm_medium=referral`} target='_blank' rel="noreferrer">{storeImagePath.userName}</a> on Unsplash</p>

                                            )}
                                        </div>
                                    </Grid>
                                </Grid>
                                <div className='shuffle-image-wrapper' style={showDefaultImage || storeImagePath.unsplashImageComponent ? { opacity: "1", cursor: "pointer" } : { opacity: "0.5", cursor: "not-allowed" }} onClick={() => (showDefaultImage || storeImagePath.unsplashImageComponent) && handleShuffleImage()}>
                                    <p>Shuffle  <ShuffleIcon sx={{ fontSize: "15px" }} /></p>
                                </div>
                            </div>
                        </div>
                    </Container>
                    <ImagepickerModal />
                </>
            )
            }
        </>
    )
}